import { parseUrl } from '@tencent/ovb-utils';
var urlTool = {
    /**
     * 将对象转换成URL形式的字符串，可以指定combineParam间隔字符，默认为’&‘
     */
    object2string: function (obj, combine) {
        if (combine === void 0) { combine = '&'; }
        return this.convertUrlParam(obj, combine, false);
    },
    /**
     * 将对象转换成URL请求参数，默认使用&连接，并且会encode对象的key和value
     * @param obj 被转换对象
     * @param combine 连接符，默认为&
     * @param needEncodeURI 是否使用encodeURIComponent转换，默认为true
     * @returns 转换后的请求字符串
     */
    convertUrlParam: function (obj, combine, needEncodeURI) {
        if (combine === void 0) { combine = '&'; }
        if (needEncodeURI === void 0) { needEncodeURI = true; }
        if (!obj) {
            return '';
        }
        var objKeys = Object.keys(obj);
        if (objKeys.length <= 0) {
            return '';
        }
        var data = [];
        objKeys.forEach(function (i) {
            var keyValueStr = '';
            if (needEncodeURI) {
                keyValueStr = "".concat(encodeURIComponent(i), "=").concat(encodeURIComponent(obj[i]));
            }
            else {
                keyValueStr = "".concat(i, "=").concat(obj[i]);
            }
            data.push(keyValueStr);
        });
        return data.join(combine);
    },
    /**
     * 通过window.location.host获取当前页面根域名，如https://v.qq.com/test.html返回qq.com
     */
    getRootDomain: function () {
        var host = window.location.hostname || window.location.host;
        var sarray = window.location.host.split('.');
        if (sarray.length > 1) {
            host = sarray.slice(sarray.length - 2).join('.');
        }
        return host;
    },
    /**
     * 获取页面顶级地址（如果有iframe嵌套的情况）
     */
    getTopFrameUrl: function () {
        var topURL = '';
        if (window.top !== window) {
            try {
                topURL = window.top.location.href;
            }
            catch (e) {
                topURL = document.referrer;
            }
        }
        else {
            topURL = window.location.href;
        }
        return topURL;
    },
    /**
     * 返回传入URL的域名地址，如传入https://v.qq.com/test.html返回v.qq.com
     */
    getDomainOfURL: function (url) {
        if (typeof url === 'undefined' || url === null || url === '') {
            return '';
        }
        try {
            return new URL(url).hostname;
        }
        catch (_a) {
            return '';
        }
    },
    /**
     * 查找并返回指定URL里key的值，如果不存在返回空字符串
     */
    getUrlParamByKey: function (url, key) {
        return parseUrl(url || location.href).query[key] || '';
    },
    /**
     * 返回指定URL里所有参数
     */
    getUrlParams: function (url) {
        return parseUrl(url || location.href).query;
    },
    /**
     * 指定更新URL里的参数
     */
    updateUrlParam: function (url, key, val) {
        var u = url;
        var oldValue = this.getUrlParamByKey(u, key);
        var newStr = "".concat(key, "=").concat(val);
        if (!oldValue) {
            u = u + (u.indexOf('?') !== -1 ? '&' : '?') + newStr;
        }
        else {
            u = u.replace("".concat(key, "=").concat(oldValue), newStr);
        }
        return u;
    },
    /**
     * 获取当前URL的文件名，如https://v.qq.com/test.html返回test.html
     */
    getFileName: function (url) {
        if (!url) {
            return null;
        }
        var fileName = url;
        var idxWH = fileName.indexOf('?');
        if (idxWH > 0) {
            fileName = fileName.slice(0, idxWH);
        }
        var idxP = fileName.lastIndexOf('/');
        if (idxP > 0) {
            fileName = fileName.slice(idxP + 1, fileName.length);
        }
        var idxHash = fileName.lastIndexOf('#');
        if (idxHash > 0) {
            fileName = fileName.slice(0, idxHash);
        }
        return fileName;
    },
    /**
     * 获取网络url地址的文件名后缀
     */
    getFileExtension: function (url) {
        if (!url) {
            return null;
        }
        if (this.isWebRTCLink(url))
            return 'webrtc';
        var fileName = urlTool.getFileName(url);
        if (fileName) {
            var splitArr = fileName.split('.');
            if (splitArr && splitArr.length > 1) {
                return splitArr[splitArr.length - 1];
            }
        }
        return null;
    },
    isWebRTCLink: function (url) {
        return /^webrtc:\/\//.test(url);
    },
};
export default urlTool;
